import { Dialog, DialogFooter, DialogType } from '@fluentui/react';
import React, { useEffect, useRef, useState } from 'react';
import { BwjButton, BwjButtonType } from '../bwj-button';
import { BwjEventArgs } from '../../entities/bwj-event';

export interface IConfirmationDialogDisplayProps {
  title?: string;
  message: string;
  proceedPrompt: string;
  cancelPrompt: string;
  onProceedRequested: (context?: any) => void;
  onCancelRequested?: (context?: any) => void;
  context?: any;
}

interface IBwjConfirmationDialogProps {
  displayArgs: BwjEventArgs<IConfirmationDialogDisplayProps | undefined> | undefined;
  closeButtonAriaLabel?: string;
}

const componentStyles = {
  main: {
    maxWidth: 450,
  }
}

export const BwjConfirmationDialog: React.FunctionComponent<IBwjConfirmationDialogProps> = (props) => {
  const [hideDialog, setHideDialog] = useState(true);
  const { displayArgs } = props;
  const dispProps = useRef<IConfirmationDialogDisplayProps>({message: '', proceedPrompt: '', cancelPrompt: '', onProceedRequested: () => {}});

  useEffect(() => {
    if(!!displayArgs && displayArgs.accessible()) {
      const dp = displayArgs.getArgs();
      if(!dp) {
        setHideDialog(true);
      } else {
        dispProps.current = dp;
        setHideDialog(false);
      }
    }
  }, [displayArgs]);

  const onProceedRequested = () => {
    !!displayProps && displayProps.onProceedRequested(displayProps.context);
    setHideDialog(true);
  };

  const onCancelRequested = () => {
    !!displayProps && !!displayProps.onCancelRequested && displayProps.onCancelRequested(displayProps.context);
    setHideDialog(true);
  };

  const displayProps = dispProps.current;
  return (
    <Dialog
      hidden={hideDialog}
      dialogContentProps={{
        type: DialogType.normal,
        title: displayProps?.title,
        subText: displayProps?.message ?? '',
        showCloseButton: true,
        closeButtonAriaLabel: props.closeButtonAriaLabel ?? 'Close dialog',
        onDismiss: onCancelRequested,
      }}
      modalProps={{
        isBlocking: true,
        styles: componentStyles,
      }}
    >
      <DialogFooter>
        <BwjButton
          buttonStyle={BwjButtonType.PrimaryStandard}
          text={displayProps?.proceedPrompt ?? ''}
          onClick={onProceedRequested}
        />
        <BwjButton
          buttonStyle={BwjButtonType.DefaultStandard}
          text={displayProps?.cancelPrompt ?? ''}
          onClick={onCancelRequested}
        />
      </DialogFooter>
    </Dialog>
  );
};
